import { action } from 'typesafe-actions';
import {
  IDeclarationStatusActionTypes,
  ResponseDeclarationStatus,
} from './Types';

export const getDeclarationStatus = (
  reference_ad_id: number,
  bucket_id: number
) =>
  action(IDeclarationStatusActionTypes.GET_DECLARATION_STATUS, {
    reference_ad_id,
    bucket_id,
  });
export const getDeclarationStatusSuccess = (
  response: ResponseDeclarationStatus
) =>
  action(
    IDeclarationStatusActionTypes.GET_DECLARATION_STATUS_SUCCESS,
    response
  );
export const getDeclarationStatusFailure = (err: string) =>
  action(IDeclarationStatusActionTypes.GET_DECLARATION_STATUS_FAILURE, err);
